<script lang="ts" setup>
import { overlaySpinnerService } from '@/services/app/overlay-spinner-service';
import { entraAuthService } from '@/services/auth/entra-auth-service';
import { hasRole } from 'cesg-shared/dist/functions/auth/permission';
import { UserRole } from 'cesg-shared/dist/models';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import Overview from '../project-overview.vue';
import { useOverviewMutation } from './mutation.ts';

const route = useRoute();
const projectId = route.params.id as string;
const user = entraAuthService.me;

const syncProject = useOverviewMutation(projectId);
const syncStarted = ref(false);

const isLoading = computed(
  () => !user.value || !syncStarted.value || syncProject.isPending.value,
);

watch(
  isLoading,
  (loading) => {
    if (loading) {
      overlaySpinnerService.show();
    } else {
      overlaySpinnerService.hide();
    }
  },
  { immediate: true },
);

onUnmounted(() => {
  if (isLoading.value) {
    overlaySpinnerService.hide();
  }
});

onMounted(() => {
  if (user.value && hasRole(UserRole.ADMIN, user.value)) {
    syncProject.mutate();
  }
  syncStarted.value = true;
});
</script>

<template>
  <Overview v-if="!isLoading && user" :project-id="projectId" :user="user" />
</template>
